var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TreeRender',_vm._b({attrs:{"nodes":_vm.nodesFiltered},scopedSlots:_vm._u([{key:"default",fn:function({ node: nodeChild, isExpanded: isExpandedChild }){return [_vm._t("default",null,{"node":nodeChild,"isExpanded":isExpandedChild})]}}],null,true)},'TreeRender',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }